import React from 'react';
import { TextFilterItem } from 'components/Filter/Filter.types';
import { SortData } from 'components/Sort/Sort.types';
import { TireSortReference } from 'domains/tires/Tire.types';
import { SparePartsViewType } from 'domains/user';
import { TireReferencesView } from './TireReferencesContainer.view';
import { useTireReferencesState } from './useTireReferencesState';

export interface TireReferencesProps {
  searchParamsBase64: string;
  sparePartsView: SparePartsViewType;
  setNumOfProducts: (num: number) => void;
  initialTextFilters?: TextFilterItem[];
  resetInitialTextFilters?: () => void;
  sort: SortData<TireSortReference>[];
}

export const TireReferencesContainer = ({
  searchParamsBase64,
  sparePartsView,
  setNumOfProducts,
  initialTextFilters,
  resetInitialTextFilters,
  sort,
}: TireReferencesProps) => {
  const {
    direction,
    margin,
    catalogTires,
    exactMatchTires,
    nonExactMatchTires,
    filters,
    textFiltersWithCurrentCounts,
    rangeFilters,
    isFilterLoading,
    showPriceless,
    setShowPriceless,
    compact,
    handleSetTextFilters,
    handleSetRangeFilters,
    handleResetFilters,
    t,
    filtersMapType,
    filtersMap,
  } = useTireReferencesState({
    searchParamsBase64,
    sparePartsView,
    setNumOfProducts,
    initialTextFilters,
    resetInitialTextFilters,
    sort,
  });

  return (
    <TireReferencesView
      direction={direction}
      margin={margin}
      searchStatus={catalogTires?.searchStatus}
      exactMatchTires={exactMatchTires}
      nonExactMatchTires={nonExactMatchTires}
      sparePartsView={sparePartsView}
      compact={compact}
      sort={sort}
      t={t}
      filters={filters}
      textFilters={textFiltersWithCurrentCounts}
      rangeFilters={rangeFilters}
      isFilterLoading={isFilterLoading}
      showPriceless={showPriceless}
      setShowPriceless={setShowPriceless}
      onSetTextFilters={handleSetTextFilters}
      onSetRangeFilters={handleSetRangeFilters}
      onResetFilters={handleResetFilters}
      filtersMapType={filtersMapType}
      filtersMap={filtersMap}
    />
  );
};
